import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Tracking } from '@panamax/app-state';
import { ProductsMapperService } from '../shared/services/products-mapper.service';
import { ProductsTrackingWrapper } from '../shared/models/products-tracking-wrapper';
import { DID_YOU_FORGET_ANALYTICS_ACTIONS } from './did-you-forget-analytics.actions';
import { DidYouForgetAnalyticsMessages } from './did-you-forget-analytics.constants';
import { defaultTransformerFunc } from './did-you-forget-analytics.transformers';

@Injectable({
  providedIn: 'root',
})
export class DidYouForgetAnalyticsService {
  constructor(private store: Store) {}

  trackPageLoad(
    productsWrapper: ProductsTrackingWrapper,
    picksWrapper: ProductsTrackingWrapper,
    merchZoneProductsWrapper: ProductsTrackingWrapper,
  ): void {
    const products = [
      ...ProductsMapperService.mapProducts(
        productsWrapper?.products,
        productsWrapper?.tracking,
      ),
      ...ProductsMapperService.mapProducts(
        picksWrapper?.products,
        picksWrapper?.tracking,
      ),
      ...(!productsWrapper?.products?.length && !picksWrapper?.products?.length
        ? ProductsMapperService.mapProducts(
            merchZoneProductsWrapper?.products,
            merchZoneProductsWrapper?.tracking,
          )
        : []),
    ];

    const tracking: Tracking = {
      analytics: {
        data: {
          page: {
            pageName: DidYouForgetAnalyticsMessages.pageName,
          },
          event: DidYouForgetAnalyticsMessages.pageLoadedEvent,
          capability: DidYouForgetAnalyticsMessages.capability,
          products,
        },
        transformFunc: defaultTransformerFunc,
      },
    };
    this.store.dispatch(
      DID_YOU_FORGET_ANALYTICS_ACTIONS.trackPageLoad({ tracking }),
    );
  }

  trackPageLoadForCoveoTopSellers(products): void {
    const tracking: Tracking = {
      analytics: {
        data: {
          page: {
            pageName: DidYouForgetAnalyticsMessages.pageName,
          },
          event: DidYouForgetAnalyticsMessages.pageLoadedEvent,
          capability: DidYouForgetAnalyticsMessages.capability,
          products,
        },
        transformFunc: defaultTransformerFunc,
      },
    };
    this.store.dispatch(
      DID_YOU_FORGET_ANALYTICS_ACTIONS.trackPageLoad({ tracking }),
    );
  }
}
